/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_CloseInputs */

const da_consent_close = /** @type {(inputs: Consent_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk`)
};

/** @type {(inputs: Consent_CloseInputs) => LocalizedString} */
const en_consent_close = da_consent_close;

/**

* @param {Consent_CloseInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_close = /** @type {((inputs?: Consent_CloseInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_CloseInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_close(inputs)
	return /** @type {LocalizedString} */ ("Luk")
});